import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 203 326",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("ellipse", {
      cx: "101.5",
      cy: "202",
      rx: "34.1683",
      ry: "34",
      fill: "#FF9600"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "101.5",
      cy: "129",
      rx: "34.1683",
      ry: "34",
      fill: "#FF9600"
    }, null, -1),
    _createElementVNode("path", {
      d: "M20.636 205.398C20.636 227.48 29.4095 246.41 44.445 259.658C59.321 272.765 79.4919 279.616 101.496 279.616C123.5 279.616 143.671 272.765 158.547 259.658C173.583 246.41 182.356 227.48 182.356 205.398C182.356 185.731 175.167 169.881 165.129 158.528C172.525 148.668 178.024 135.31 178.024 119.629C178.024 100.921 171.136 82.8532 157.678 69.4405C144.132 55.9408 124.799 48.0099 101.496 48.0099C78.1925 48.0099 58.8603 55.9408 45.3143 69.4405C31.8555 82.8532 24.9678 100.921 24.9678 119.629C24.9678 135.31 30.467 148.668 37.8626 158.528C27.8247 169.881 20.636 185.731 20.636 205.398ZM101.496 128.004C98.5895 128.004 96.7743 126.974 95.6233 125.759C94.3798 124.447 93.41 122.364 93.41 119.629C93.41 116.668 94.4339 114.512 95.6662 113.2C96.804 111.989 98.5948 110.965 101.496 110.965C104.397 110.965 106.188 111.989 107.326 113.2C108.558 114.512 109.582 116.668 109.582 119.629C109.582 122.364 108.612 124.447 107.369 125.759C106.218 126.974 104.402 128.004 101.496 128.004ZM89.367 203.665C89.367 199.009 90.8856 195.978 92.6204 194.189C94.3126 192.445 97.0939 190.959 101.496 190.959C105.898 190.959 108.679 192.445 110.372 194.189C112.106 195.978 113.625 199.009 113.625 203.665C113.625 208.533 112.064 211.636 110.334 213.433C108.653 215.179 105.894 216.661 101.496 216.661C97.0977 216.661 94.3391 215.179 92.658 213.433C90.9282 211.636 89.367 208.533 89.367 203.665Z",
      fill: "white",
      stroke: "#FF9600",
      "stroke-width": "28.8786"
    }, null, -1)
  ])))
}
export default { render: render }